import React from "react";
import { Card } from "antd";

export const HowItWorksCard = () => {
  return (
    <Card
      title="How It Works"
      bordered={false}
      className="bg-white rounded-lg border border-gray-200"
    >
      <p className="text-sm text-gray-600 mb-4">
        This integration connects your Kaizen POS inventory to WhatsApp,
        allowing customers to query your shop directly via chat.
      </p>

      <p className="text-sm font-semibold text-gray-700 mb-2">Features</p>
      <ul className="list-disc pl-5 text-sm text-gray-600 space-y-2 m-0">
        <li>
          <strong>AI Product Search:</strong> Customers can ask if you have
          specific items (e.g. <em>"Do you have LED monitors?"</em>). The bot
          searches your active store inventory automatically.
        </li>
        <li>
          <strong>General Store Info:</strong> Automatically answers questions
          about your store name, locations, and details.
        </li>
        <li>
          <strong>Gemini Integration:</strong> Uses advanced language models to
          chat naturally and understand synonyms and typos.
        </li>
      </ul>

      <div className="mt-5 pt-4 border-t border-gray-100">
        <p className="text-xs text-gray-400 m-0">
          <strong>Tip:</strong> Keep the gateway server running continuously
          for the best experience. Use a process manager like{" "}
          <code className="bg-gray-100 px-1 rounded">pm2</code> in production.
        </p>
      </div>
    </Card>
  );
};
